<script>
    /**
     * @typedef {Object} Props
     * @property {boolean} [isOpen] - If tooltip should be visbile
     * @property {boolean} [noArrow] - If arrow poiting to alignment should be shown
     * @property {string} [alignment] - Can be 'top', 'bottom', 'right', 'top-left'
     * @property {import('svelte').Snippet} [children]
     */

    /** @type {Props} */
    let {
        isOpen = $bindable(false),
        canBeClosed = true,
        noArrow = false,
        isCompact = false,
        alignment = 'bottom',
        children,
    } = $props()

    let selfElement = $state()

    function onClickDocument(event) {
        if (!isOpen) {
            return
        }
        if (selfElement.contains(event.target)) {
            return
        }
        isOpen = false
    }
</script>

<svelte:document onclick={canBeClosed ? onClickDocument : null} />

{#if isOpen}
    <div
        class="tooltip"
        bind:this={selfElement}
        class:no-arrow={noArrow}
        class:alignment-top={alignment === 'top'}
        class:alignment-top-left={alignment === 'top-left'}
        class:alignment-bottom={alignment === 'bottom'}
        class:alignment-right={alignment === 'right'}
        class:compact={isCompact}
    >
        <div class="content">
            {@render children?.()}
        </div>
    </div>
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.tooltip {
  border-radius: 16px;
  font-size: 14px;
  z-index: 9200;
  position: absolute;
  left: 50%;
  display: block;
  width: max-content;
  background: #fff;
  color: #122d40;
  user-select: none;
  cursor: default;
  border: 1px solid hsl(40, 4%, 84%);
}
.tooltip:not(.tooltip.compact) {
  box-shadow: 0 10px 30px 0 rgba(18, 45, 64, 0.12);
}
.tooltip:not(.tooltip.no-arrow):after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 50%;
  height: 10px;
  width: 10px;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  background: inherit;
  border: 1px solid hsl(40, 4%, 84%);
}
.tooltip.alignment-top {
  top: 0;
  transform: translateX(-50%) translateY(-100%) translateY(-10px);
}
.tooltip.alignment-top:not(.tooltip.alignment-top.no-arrow):after {
  top: calc(100% + 1px);
  border-top: none;
  border-left: none;
}
.tooltip.alignment-top-left {
  top: 0;
  left: 0;
  transform: translateY(-100%) translateY(-10px);
}
.tooltip.alignment-top-left:not(.tooltip.alignment-top-left.no-arrow):after {
  top: calc(100% + 1px);
  left: 18px;
  border-top: none;
  border-left: none;
}
.tooltip.alignment-bottom {
  top: 100%;
  transform: translateX(-50%) translateY(10px);
}
.tooltip.alignment-bottom:not(.tooltip.alignment-bottom.no-arrow):after {
  top: 1px;
  border-right: none;
  border-bottom: none;
}
.tooltip.alignment-right {
  left: 100%;
  top: 50%;
  transform: translateX(10px) translateY(-50%);
}
.tooltip.alignment-right:not(.tooltip.alignment-right.no-arrow):after {
  left: 0;
  top: 50%;
  border-top: none;
  border-right: none;
}

.content {
  padding: 8px 16px;
  display: grid;
  gap: 4px;
  grid-template-rows: min-content min-content;
  grid-template-columns: 1fr;
}
.content > :global(div:empty) {
  display: none;
}
.content :global(svg),
.content :global(img) {
  height: 16px;
  width: 16px;
}

.compact {
  top: 16px !important;
}
.compact .content {
  display: flex;
  padding: 2px 8px;
  gap: 0px;
}
.compact .content:has(:global(svg:first-child)) {
  padding-inline-start: 4px;
}</style>
